import React from "react";
import { Button as MuiButton, makeStyles } from "@material-ui/core";
import tokens from "../designTokens";

const useStyles = makeStyles({
  root: {
    textTransform: "none",
    fontFamily: tokens.fontBody,
    fontWeight: 500,
    borderRadius: tokens.radiusDefault,
    whiteSpace: "nowrap",
  },
  sm: { height: 32, padding: "0 12px", fontSize: 12.5 },
  md: { height: 40, padding: "0 18px", fontSize: 13.5 },
  lg: { height: 48, padding: "0 24px", fontSize: 14.5 },
  primary: {
    background: tokens.primary,
    color: "#fff",
    "&:hover": { background: "#083A3E" },
    "&.Mui-disabled": { background: tokens.disabledFill, color: tokens.textDisabled },
  },
  cta: {
    background: tokens.green,
    color: "#fff",
    "&:hover": { background: "#00A85F" },
    "&.Mui-disabled": { background: tokens.disabledFill, color: tokens.textDisabled },
  },
  outlined: {
    background: tokens.surface,
    color: tokens.textPrimary,
    borderColor: tokens.borderStrong,
    "&:hover": { background: tokens.primaryLight },
    "&.Mui-disabled": { color: tokens.textDisabled, borderColor: tokens.border },
  },
  danger: {
    color: tokens.error,
    borderColor: tokens.error,
    "&:hover": { background: "#FDECEA" },
    "&.Mui-disabled": { color: tokens.textDisabled, borderColor: tokens.border },
  },
  text: {
    color: tokens.primary,
    padding: "0 6px",
    "&:hover": { background: tokens.primaryLight },
  },
});

const MUI_VARIANT = { primary: "contained", cta: "contained", outlined: "outlined", danger: "outlined", text: "text" };

export default function Button({ children, variant = "primary", size = "md", icon, iconRight, fullWidth = false, type = "button", style, ...rest }) {
  const classes = useStyles();
  const variantClass = classes[variant] || classes.primary;
  const sizeClass = classes[size] || classes.md;
  return (
    <MuiButton
      type={type}
      variant={MUI_VARIANT[variant] || "contained"}
      className={`${classes.root} ${sizeClass} ${variantClass}`}
      fullWidth={fullWidth}
      disableElevation
      startIcon={icon}
      endIcon={iconRight}
      style={style}
      {...rest}
    >
      {children}
    </MuiButton>
  );
}
